/**
 * Sentry initialization for the KARM Safety web + Capacitor app.
 * Called once at bootstrap in src/index.js.
 */
import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return; // no-op in dev / when unconfigured

  Sentry.init({
    dsn,
    // Environment tag: "production" for the built bundle, "preview" everywhere else.
    environment: process.env.REACT_APP_ENV || "preview",
    release: `karm-safety-web@${process.env.REACT_APP_VERSION || "1.0.0"}`,

    // Trace 10% of transactions in prod to stay comfortably under free-tier quota.
    tracesSampleRate: process.env.REACT_APP_ENV === "production" ? 0.1 : 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Privacy-safe defaults: mask every text node + every input.
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],

    // Session Replay: never on healthy sessions, always on error sessions.
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,

    // Don't ship known noise from browser extensions or aborted network requests.
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "Non-Error promise rejection captured",
      "Network request failed", // offline / aborted fetches
    ],
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;

/** Attach the current user to every Sentry event. Call after login. */
export function setSentryUser(user) {
  if (!user) { Sentry.setUser(null); return; }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    role: user.role,
    company_id: user.company_id,
  });
}
